import { GenService } from "./gen-ser.service";

export class RTCToken{
    constructor(public serialNo:string, public relPath:string, public utcTimeToken:number, public productId:string){

    }
}

export class SearchParams{
    constructor(public filterManfDate:boolean, public manfFromDate:Date, public manfToDate:Date,
        public plantId:string, public serialOptSelection:string,  public pastedSerialNosStr:string,
        public fromSerialNo:string, public toSerialNo:string, public serialExtractMessage:string,
        public extractedSerialNumbers:Array<string>, public serialNos:Array<string>){}
}

export class DrawToken{
    constructor(public soNo:string, public relPath:string, public utcTimeToken:number, public productId:string){

    }
}
export class SearchParamsDraw{
    constructor(public filterUploadDate:boolean, public uploadFromDate:Date, public uploadToDate:Date,
        public plantId:string, public soOptSelection:string,  public pastedSONosStr:string,
        public fromSONo:string, public toSONo:string, public soExtractMessage:string,
        public extractedSONumbers:Array<string>, public soNos:Array<string>){}
}

export class ProductGroup{
    constructor(private _id:string, private _name:string, private _icon_ref:string,
                private _order:number, private _hasUploadAccess:boolean, private _hasDownloadAccess:boolean, private _hasDrawUploadAccess:boolean, private _hasDrawDownloadAccess:boolean, 
                private _products:Array<Product>){

                }
    get id():string{
        return this._id;
    }
    get name():string{
        return this._name;
    }
    get iconRef():string{
        return this._icon_ref;
    }
    get order():number{
        return this._order;
    }
    get products():Array<Product>{
        return this._products;
    }
    get hasDownloadAccess():boolean{
        return this._hasDownloadAccess;
    }
    get hasUploadAccess():boolean{
        return this._hasUploadAccess;
    }
    get hasDrawUploadAccess():boolean{
        return this._hasDrawUploadAccess;
    }
    get hasDrawDownloadAccess():boolean{
        return this._hasDrawDownloadAccess;
    }
}

export class Product{
    public isSelected:boolean = false;
    public isSelectedDraw:boolean = false;
    constructor(private _name:string, private _plant_code:string, private _product_code:string,private _rtc_folder:string,
                private _draw_folder:string, private _order:number){

    }

    get name():string{
        return this._name;
    }
    get plantCode():string{
        return this._plant_code;
    }
    get productCode():string{
        return this._product_code;
    }
    get rtcFolder():string{
        return this._rtc_folder;
    }
    get drawFolder():string{
        return this._draw_folder;
    }
    get isRTCFolderExists():boolean{
        if(this._rtc_folder && this._rtc_folder != "") return true;
        return false;
    }
    get isDrawFolderExists():boolean{
        if(this._draw_folder && this._draw_folder != "") return true;
        return false;
    }
    get order():number{
        return this._order;
    }
}
export class fileObj {
	constructor(public filepath: string, public fileName: string, public categoryName: string, public uploadDateTime: String) {
	}
}